module.exports = __webpack_public_path__ + "static/media/nouvelr-bold.ec1bab9f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/nouvelr/nouvelr-bold.woff2
// module id = 939
// module chunks = 0